import React, { useCallback } from 'react';
import { Pagination as MuiPagination, Box } from '@mui/material';

export interface PaginationProps {
  setPage: (newPage: number) => void;
  currentPage: number;
  pageCount: number;
  itemCount?: number;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export function Pagination({
  setPage,
  currentPage,
  pageCount,
  size = 'medium',
  className,
}: PaginationProps) {
  const handleChange = useCallback(
    (_event: React.ChangeEvent<unknown>, page: number) => {
      setPage(page);
    },
    [setPage],
  );

  if (pageCount < 2) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
      <MuiPagination
        count={pageCount}
        page={currentPage}
        onChange={handleChange}
        size={'small'}
        className={className}
        showFirstButton
        showLastButton
        siblingCount={2}
        boundaryCount={0}
        color="primary"
      />
    </Box>
  );
}
